module.exports = "/src/views/games/other/images/roles/courtesan.png";